import React, { useState } from "react";
import { Accordion, ListGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  ADMIN_SIDEBAR_NAV_MENU_ITEMS,
  ESS_SIDEBAR_NAV_MENU_ITEMS,
} from "../../constants/constants";
import { withRouter } from "../../utils/withRouter";
import { useSelector } from "react-redux";

function SideNav(props) {
  const [outerActiveEventKey, setOuterActiveEventKey] = useState([]);
  const authUser = useSelector((state) => state.auth.currentUser);
  const { location } = props;

  const handleOuterAccordionChange = (eventKey) => {
    let updatedState;
    if (outerActiveEventKey.includes(eventKey)) {
      updatedState = outerActiveEventKey.filter((key) => key !== eventKey);
    } else {
      updatedState = [eventKey];
    }
    setOuterActiveEventKey(updatedState);
  };

  const SIDEBAR_NAV_MENU_ITEMS =
    authUser === "Admin"
      ? ADMIN_SIDEBAR_NAV_MENU_ITEMS
      : ESS_SIDEBAR_NAV_MENU_ITEMS;

  return (
    <div className={`sidebar-wrapper`}>
      <ul className="metismenu">
        {SIDEBAR_NAV_MENU_ITEMS.subMenu.length > 0 && (
          <li className="p-0">
            <Accordion
              activeKey={outerActiveEventKey}
              onSelect={handleOuterAccordionChange}
            >
              {SIDEBAR_NAV_MENU_ITEMS.subMenu.map((item, idx) => (
                <MyAccordion
                  key={idx}
                  item={item}
                  eventKey={`${idx}`}
                  location={location}
                />
              ))}
            </Accordion>
          </li>
        )}
      </ul>
    </div>
  );
}

export default withRouter(SideNav);

const MyAccordion = ({ item, eventKey, location }) => {
  const navigate = useNavigate();

  const isActive = location.pathname === item.path;

  return (
    <Accordion.Item
      eventKey={eventKey}
      className="border-bottom border-0 border-bottom-1"
    >
      <Accordion.Header
        className={`${!item.children ? "no-arrow" : ""}`}
        style={{ padding: "0px", marging: "0px" }}
      >
        <ListGroup.Item
          as="div"
          className="w-100 "
          style={{ position: "relative" }}
        >
          {/*  If item has children -> no navigation */}
          {!item.children ? (
            <Link
              to={item.path ? item.path : "#"}
              aria-expanded="false"
              className={`d-flex  ${isActive ? "text-primary fw-bold" : ""}`}
              style={{ paddingInline: "0.5rem", paddingBlock: "0.4rem" }}
              onClick={(e) => {
                if (isActive) {
                  e.preventDefault();
                } else {
                  navigate(item.path);
                }
              }}
            >
              <span className="fs-14">{item.icon}</span>
              <span className="small-text fw-500 sidebar-lable">
                {item.name}
              </span>
            </Link>
          ) : (
            <div
              className="d-flex"
              style={{ paddingInline: "0.5rem", paddingBlock: "0.4rem" }}
            >
              <span className="fs-14">{item.icon}</span>
              <span className="small-text fw-500 sidebar-lable">
                {item.name}
              </span>
            </div>
          )}
        </ListGroup.Item>
      </Accordion.Header>

      {/*  Only render children when present */}
      {item.children && (
        <Accordion.Body>
          <Accordion>
            {item.children.map((child, idx) => (
              <MyAccordion
                key={idx}
                item={child}
                eventKey={`${eventKey}-${idx}`}
                location={location}
              />
            ))}
          </Accordion>
        </Accordion.Body>
      )}
    </Accordion.Item>
  );
};
